import React from 'react';
import { Trash2, Edit2, Mail, Phone, Globe } from 'lucide-react';
import { Card, CardContent } from '../../ui/card';
import { tierMeta } from './constants';

const ICON_BTN = (color) => ({
  background: 'transparent',
  border: 'none',
  color,
  cursor: 'pointer',
});

const TIER_BADGE_STYLE = (color) => ({
  display: 'inline-block',
  marginTop: '0.25rem',
  padding: '2px 8px',
  borderRadius: '999px',
  background: color,
  color: '#000',
  fontSize: '0.7rem',
  fontWeight: 800,
  textTransform: 'uppercase',
});

const SponsorCard = ({ sponsor: s, onEdit, onDelete }) => {
  const meta = tierMeta(s.tier);
  return (
    <Card
      className="data-card"
      style={{ borderTop: `4px solid ${meta.color}` }}
      data-testid={`sponsor-card-${s.id}`}
    >
      <CardContent>
        <div style={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', gap: '0.5rem' }}>
          <div style={{ flex: 1 }}>
            <h3 style={{ margin: 0, color: '#fff', fontSize: '1.1rem' }}>{s.business_name}</h3>
            <span style={TIER_BADGE_STYLE(meta.color)}>{meta.label}</span>
            {s.status !== 'active' && (
              <span style={{ marginLeft: 6, padding: '2px 8px', borderRadius: '999px', background: '#444', color: '#fff', fontSize: '0.7rem' }}>
                {s.status}
              </span>
            )}
          </div>
          <div style={{ display: 'flex', gap: '0.25rem' }}>
            <button
              type="button"
              onClick={() => onEdit(s)}
              title="Edit sponsor"
              style={ICON_BTN('#FFD700')}
              data-testid={`edit-sponsor-${s.id}`}
            >
              <Edit2 size={16} />
            </button>
            <button
              type="button"
              onClick={() => onDelete(s)}
              title="Delete sponsor"
              style={ICON_BTN('#ef4444')}
              data-testid={`delete-sponsor-${s.id}`}
            >
              <Trash2 size={16} />
            </button>
          </div>
        </div>

        {s.amount > 0 && (
          <div style={{ marginTop: '0.5rem', color: '#10b981', fontWeight: 700 }}>
            ${Number(s.amount).toLocaleString()}
          </div>
        )}
        {s.contact_name && (
          <div style={{ marginTop: '0.5rem', color: '#ddd', fontSize: '0.9rem' }}>{s.contact_name}</div>
        )}
        {s.email && (
          <div style={{ marginTop: '0.25rem', fontSize: '0.85rem' }}>
            <Mail size={12} style={{ verticalAlign: 'middle', color: '#FFD700' }} />{' '}
            <a href={`mailto:${s.email}`} style={{ color: '#fff' }}>{s.email}</a>
          </div>
        )}
        {s.phone && (
          <div style={{ marginTop: '0.15rem', fontSize: '0.85rem' }}>
            <Phone size={12} style={{ verticalAlign: 'middle', color: '#FFD700' }} />{' '}
            <a href={`tel:${s.phone}`} style={{ color: '#fff' }}>{s.phone}</a>
          </div>
        )}
        {s.website && (
          <div style={{ marginTop: '0.15rem', fontSize: '0.85rem' }}>
            <Globe size={12} style={{ verticalAlign: 'middle', color: '#FFD700' }} />{' '}
            <a href={s.website} target="_blank" rel="noopener noreferrer" style={{ color: '#fff' }}>
              {s.website}
            </a>
          </div>
        )}
        {s.renewal_date && (
          <div style={{ marginTop: '0.5rem', fontSize: '0.8rem', color: '#f59e0b' }}>
            Renews {new Date(s.renewal_date).toLocaleDateString()}
          </div>
        )}
        {s.notes && (
          <p style={{ marginTop: '0.5rem', color: '#bbb', fontSize: '0.85rem' }}>{s.notes}</p>
        )}
      </CardContent>
    </Card>
  );
};

export default SponsorCard;
